import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './request'
import Storage from 'vue-ls'


import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import VueClipboards from 'vue-clipboard2'

import { TOKEN, USER_ID, REDIRECT_URL,USER_NAME } from "@/store/mutation-types";

import VueCookies from 'vue-cookies'
import commonFunction from '@/utils/commonFunction'
import '@/utils/permission'
import { downloadFile } from './request/http';

Vue.use(commonFunction)
Vue.use(VueCookies)

Vue.use(VueClipboards);
Vue.use(Antd)

//注册全局api属性
Vue.prototype.$api = api;
// Vue.prototype.$message = message;
Vue.prototype.$downloadFile = downloadFile;

Vue.prototype.$eventBus = new Vue()
Vue.config.productionTip = false

Vue.use(Storage, {
  namespace: 'pro__', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local', // storage name session, local, memory
})

new Vue({
  router,
  store,
  mounted() {
    store.commit('saveToken', Vue.ls.get(TOKEN))
    store.commit('saveUserId', Vue.ls.get(USER_ID))
    store.commit('saveUserName', Vue.ls.get(USER_NAME))
  },
  render: h => h(App)
}).$mount('#app')

